import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { type MatrixValue } from '../../../core';
import { Zones } from './repository';
import { Zone } from './entity';
import { type ZoneData } from './dto';

export class ZonesCommands implements Commands<Zones, Zone, ZoneData> {
    addAllWithMatrix(
        repo: Zones,
        data: ZoneData[],
        matrix: MatrixValue[],
    ): Zones {
        repo.clear();
        data.forEach((zoneData) => {
            repo.add(
                new Zone({
                    id: zoneData.id,
                    name: zoneData.name,
                    description: zoneData.description,
                    parentZoneId: zoneData.parentZone?.id,
                    exposureId: matrix.find(
                        (m) =>
                            m.name.toLowerCase() ===
                            zoneData.exposureRating.toLowerCase(),
                    )?.id,
                }),
            );
        });
        return repo;
    }

    addAll(repo: Zones, data: ZoneData[]): Zones {
        repo.clear();
        data.forEach((zoneData) => {
            this.add(repo, zoneData);
        });
        return repo;
    }

    add(repo: Zones, data: ZoneData): Zones {
        const zone = new Zone({
            id: data.id,
            name: data.name,
            description: data.description,
            parentZoneId: data.parentZone?.id,
        });
        repo.add(zone);
        return repo;
    }

    update(repo: Zones, entity: Zone): Zone {
        repo.update(entity);
        return entity;
    }

    remove(repo: Zones, id: string): void {
        repo.remove(id);
    }

    create(repo: Zones, data: Omit<ZoneData, 'id'>): Zone {
        const uuid = new UUID();
        const zone = new Zone({
            id: uuid.toString(),
            name: data.name,
            description: data.description,
            parentZoneId: data.parentZone?.id,
        });
        repo.add(zone);
        return zone;
    }

    fromJSON(entity: Zone[], changeCallback: () => void): Zones {
        const newZones = new Zones(changeCallback);
        entity.forEach((zone) => {
            newZones.add(
                new Zone({
                    ...zone,
                }),
            );
        });
        return newZones;
    }
}
